import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SidebarHeader, ScrollableBox, CancelButton, Feature } from '@mssgme/ui';

import { PageLayout } from '../../../UI';

export default function DomainLayout({ rightButton, children }) {
    const { t } = useTranslation('cards');
    const location = useLocation();
    const returnTo = (location.state && location.state.returnTo) || '/p/settings/url';
    const leftButton = <CancelButton tag={Link} to={returnTo} styled="backIcon" />;

    return (
        <PageLayout>
            <SidebarHeader heading={t('domain.heading')} leftButton={leftButton} rightButton={rightButton} />
            <ScrollableBox>
                <Feature rule="domain">{children}</Feature>
            </ScrollableBox>
        </PageLayout>
    );
}

DomainLayout.propTypes = {
    blocked: PropTypes.bool,
    rightButton: PropTypes.node,
    children: PropTypes.node,
};
